import { keyBy } from "lib/keyBy"
import { pick } from "lib/pick"
import { Box, Chip, Stack } from "@mui/material"
import { formatTime } from "lib/format-time"
import Iconify from "minimals-template/components/Iconify"
import { alpha } from "@mui/material/styles"
import { getHexColor } from "lib/get-hex-color"
import {
    COLOR_FROM_CLASSIFICATION,
    ICON_FROM_CLASSIFICATION,
    VALID_CLASSIFICATIONS_REVERSE,
} from "library/SFG20/constants.mjs"

import { WheelChart } from "lib/@components/wheel-chart"
import { getContrastingColor } from "lib/get-contrasting-color"

export function findFolderInStats(stats, folder) {
    if (!stats?.stats?.children) return null
    const id = (folder.id ?? folder).split("!")[1]
    return stats.stats.children.find((s) => s.id === id)
}

export function FolderClassifications({ stats, entry, originalChildren }) {
    const folderStats = findFolderInStats(stats, entry)
    if (!folderStats)
        return (
            <Box display="flex">
                <Box ml={-4}>{originalChildren}</Box>
                <Box width={56} />
            </Box>
        )
    const classifications = keyBy(folderStats.total, pick("classification"))
    return (
        <Stack direction="row" spacing={1}>
            {VALID_CLASSIFICATIONS_REVERSE.map(
                (classification) =>
                    !!classifications[classification]?.count && (
                        <Chip
                            size="small"
                            key={classification}
                            sx={{
                                zoom: 0.8,
                                ml: 2,
                                color: getContrastingColor(COLOR_FROM_CLASSIFICATION[classification]),
                                bgcolor: alpha(getHexColor(COLOR_FROM_CLASSIFICATION[classification]), 0.8),
                            }}
                            label={`${classification} (${classifications[classification].count})`}
                            icon={
                                <Box
                                    pt={0.5}
                                    sx={{
                                        color: `${getContrastingColor(
                                            COLOR_FROM_CLASSIFICATION[classification]
                                        )} !important`,
                                    }}
                                >
                                    <Iconify icon={ICON_FROM_CLASSIFICATION[classification]} />
                                </Box>
                            }
                        />
                    )
            )}
            <Box width={12} />
        </Stack>
    )
}

export function FolderCompleteness({ stats, entry, originalChildren }) {
    const folderStats = findFolderInStats(stats, entry)
    if (!folderStats)
        return (
            <Box display="flex">
                <Box ml={-4}>{originalChildren}</Box>
                <Box width={82} />
            </Box>
        )

    return (
        <WheelChart
            percentage={(folderStats.totalAnnualMinutes / stats.annualMinutes) * 100}
            label={formatTime(folderStats.totalAnnualMinutes)}
        >
            {originalChildren}
        </WheelChart>
    )
}
